// extracted by mini-css-extract-plugin
export var article = "rules-post-module--article--pdHKy";
export var articleNavigation = "rules-post-module--articleNavigation--xWcKa";
export var body = "rules-post-module--body--2ag58";
export var container = "rules-post-module--container--pqD9W";
export var meta = "rules-post-module--meta--ua10+";